import { render, staticRenderFns } from "./normal-header.vue?vue&type=template&id=8a0f48f0&scoped=true&"
import script from "./normal-header.vue?vue&type=script&lang=ts&"
export * from "./normal-header.vue?vue&type=script&lang=ts&"
import style0 from "./normal-header.vue?vue&type=style&index=0&id=8a0f48f0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a0f48f0",
  null
  
)

export default component.exports